import getEnvironment from "../helpers/getEnvironment";

const pushToDigitalData = (analyticsData: any): void => {
  if (getEnvironment() === "localhost") {
    return;
  }

  //@ts-ignore
  if (window.digitalData) {
    try {
      // @ts-ignore
      digitalData.push(analyticsData);
    } catch (error) {
      console.error(error);
    }
  }
};

export default pushToDigitalData;
